<template>
    <component :is="Selected" />
  </template>
  
  <script setup>
  import { computed } from "vue";
  import { useRoute } from "vue-router";
  
  import Current from "./ReportView.vue";
  import Legacy from "./ReportView.legacySurvey.vue";
  
  // Switch with: /report-preview?v=old
  const route = useRoute();
  // Swap mapping:
  // - /report-preview => Legacy
  // - /report-preview?v=old => Current
  const Selected = computed(() => (route.query.v === "old" ? Current : Legacy));
  </script>